/** Current browser bundle version included with beta-form diagnostic metadata. */
export const ADVISOR_VERSION = '1.3.0';
